// src/schemas/typebox/admin/schema-validators.ts
import { Type as Type2 } from "@sinclair/typebox";

// src/schemas/typebox/schema-validator.ts
import { Value } from "@sinclair/typebox/value";
var SchemaValidator = class {
  // readonly #validator;
  constructor(schema) {
    this.validate = (obj) => {
      return Value.Check(this.schema, obj);
    };
    this.schema = schema;
  }
};

// src/schemas/typebox/shared-schemas.ts
import { Type } from "@sinclair/typebox";
function OptionalOrNull(type) {
  return Type.Optional(Type.Union([Type.Null(), type]));
}
function PaginatedResults(type, keyName = "results") {
  const properties = {
    currentPage: Type.Number(),
    totalElements: Type.Number(),
    totalPages: Type.Number(),
    [keyName]: Type.Array(type)
  };
  return Type.Object(properties);
}

// src/schemas/typebox/admin/schema-validators.ts
var activeVerityDeployment = new SchemaValidator(
  Type2.Object({
    deploymentId: OptionalOrNull(Type2.String()),
    clientId: OptionalOrNull(Type2.String()),
    iss: OptionalOrNull(Type2.String())
  })
);
var deployment = new SchemaValidator(
  Type2.Object({
    id: OptionalOrNull(Type2.Number()),
    deploymentId: Type2.String(),
    lti1p3ClientRegistrationId: Type2.Number(),
    instituteId: OptionalOrNull(Type2.String())
  })
);
var deployments = new SchemaValidator(
  Type2.Object({
    deployments: Type2.Array(
      Type2.Object({
        id: Type2.Number(),
        deploymentId: Type2.String(),
        lti1p3ClientRegistrationId: Type2.Number(),
        instituteId: OptionalOrNull(Type2.String())
      })
    ),
    instituteId: Type2.String()
  })
);
var clientRegistrationId = new SchemaValidator(
  Type2.Object({
    clientRegistrations: Type2.Array(
      Type2.Object({
        id: Type2.Number()
      })
    )
  })
);
var upsertedClientRegistrationId = new SchemaValidator(
  Type2.Number()
);
var clientRegistration = new SchemaValidator(
  Type2.Object({
    id: Type2.Number(),
    iss: Type2.String(),
    clientId: Type2.String(),
    authorizationUri: Type2.String(),
    jwkSetUri: Type2.String(),
    instituteId: Type2.String()
  })
);
var schema_validators_default = {
  activeVerityDeployment,
  deployment,
  deployments,
  clientRegistrationId,
  upsertedClientRegistrationId,
  clientRegistration
};

// src/schemas/typebox/assessment/schema-validators.ts
import { Type as Type4 } from "@sinclair/typebox";

// src/schemas/typebox/verity-options/schema-validators.ts
import { Type as Type3 } from "@sinclair/typebox";
import { VideoPlatformSchema } from "@verity/database/zod";
var recordingModeType = Type3.Union([Type3.Literal("off"), Type3.Literal("normal"), Type3.Literal("strict")]);
var proctoringOptionsType = Type3.Object({
  enforceLockdown: Type3.Boolean(),
  enforceMobile: Type3.Boolean(),
  isExtension: Type3.Boolean(),
  isLockdown: Type3.Boolean(),
  isMobile: Type3.Boolean(),
  isChromeOs: Type3.Boolean(),
  videoRecordingMode: recordingModeType,
  secondaryVideoRecordingMode: recordingModeType,
  audioRecordingMode: recordingModeType,
  recordScreen: Type3.Boolean(),
  recordWebTraffic: Type3.Boolean(),
  detectSidePanel: Type3.Boolean(),
  excludedWebTrafficRecordingUrls: OptionalOrNull(Type3.Array(Type3.String())),
  recordClipboard: Type3.Boolean(),
  recordInput: Type3.Boolean(),
  oneScreenEnforcementMode: recordingModeType,
  disableNewTab: Type3.Boolean(),
  closeOpenTabs: Type3.Boolean(),
  tabWhiteList: OptionalOrNull(Type3.Array(Type3.String())),
  tabBlockList: OptionalOrNull(Type3.Array(Type3.String())),
  keyboardShortcutBlockList: OptionalOrNull(Type3.Array(Type3.String())),
  disableClipboardMode: Type3.Union([Type3.Literal("off"), Type3.Literal("tab"), Type3.Literal("system")]),
  enableGuidedAccessMode: Type3.Boolean(),
  restrictHandoffMode: recordingModeType,
  disableSpellcheck: Type3.Boolean(),
  disablePrinting: Type3.Boolean(),
  disableRightClick: Type3.Boolean(),
  extensionBlockMode: recordingModeType,
  allowedExtensionsList: OptionalOrNull(Type3.Array(Type3.String())),
  logInstalledExtensions: Type3.Boolean(),
  disableDownloadFiles: Type3.Boolean(),
  hideOtherWindows: Type3.Boolean(),
  showRecordingPanel: Type3.Boolean(),
  idVerification: Type3.Boolean(),
  idVerificationEnableAi: Type3.Boolean(),
  faceTrackingMode: recordingModeType,
  objectDetectionMode: recordingModeType,
  applicationBlockMode: recordingModeType,
  applicationBlockList: OptionalOrNull(Type3.Array(Type3.String())),
  blockVirtualMachines: Type3.Boolean(),
  recordApplicationsActivity: Type3.Boolean(),
  isLiveProctored: Type3.Boolean(),
  isLivePopIn: Type3.Boolean(),
  enablePostReview: Type3.Boolean(),
  scanRoom: Type3.Boolean(),
  quietEnvironment: Type3.Boolean(),
  enableCalculator: Type3.Union([Type3.Literal("off"), Type3.Literal("scientific"), Type3.Literal("standard")]),
  enableWhiteboard: Type3.Boolean(),
  enableCodeEditor: Type3.Boolean(),
  codeEditorRoomId: OptionalOrNull(Type3.Array(Type3.String(), { maxItems: 1 })),
  uploadScratchNotes: Type3.Boolean(),
  idVerificationMode: recordingModeType,
  restrictDevices: Type3.Boolean(),
  audioTranscription: Type3.Boolean(),
  flaggedKeywords: Type3.Union([
    Type3.Null(),
    Type3.Array(
      Type3.Object({
        keyword: Type3.String(),
        level: Type3.Optional(Type3.Number())
      })
    )
  ]),
  uploadSignature: Type3.Boolean(),
  enableGeofence: Type3.Boolean(),
  geofenceLocations: OptionalOrNull(
    Type3.Array(
      Type3.Object({
        longitude: Type3.Number(),
        latitude: Type3.Number(),
        radius: Type3.Number(),
        name: Type3.String(),
        isMetric: Type3.Boolean()
      })
    )
  ),
  disableVirtualCamera: Type3.Boolean()
});
var chromeOsAccessType = OptionalOrNull(
  Type3.Union([Type3.Literal("managed-guest-session"), Type3.Literal("all")])
);
var candidateInterviewOptionsBaseType = Type3.Object({
  candidateEmail: Type3.String(),
  candidateName: Type3.String(),
  meetingLink: Type3.String(),
  notes: OptionalOrNull(Type3.String()),
  positionName: Type3.String(),
  title: Type3.String(),
  videoPlatform: Type3.Enum(VideoPlatformSchema.enum)
});
var candidateInterviewOptionsGetType = Type3.Intersect([
  candidateInterviewOptionsBaseType,
  Type3.Object({
    id: Type3.Number()
  })
]);
var candidateInterviewOptionsSaveType = Type3.Intersect([
  candidateInterviewOptionsBaseType,
  Type3.Object({
    id: OptionalOrNull(Type3.Number())
  })
]);
var verityOptions = new SchemaValidator(
  Type3.Object({
    ...proctoringOptionsType.properties,
    enabled: Type3.Boolean(),
    requiresIncognito: Type3.Boolean(),
    chromeOsAccess: chromeOsAccessType,
    automaticallyAddedAllowedUrls: OptionalOrNull(Type3.Array(Type3.String())),
    logEvents: Type3.Boolean(),
    password: OptionalOrNull(Type3.String()),
    thirdPartyAssessmentOptions: OptionalOrNull(
      Type3.Object({
        thirdPartyUrl: OptionalOrNull(Type3.String()),
        password: OptionalOrNull(Type3.String()),
        thirdPartyPlatformId: OptionalOrNull(Type3.Number())
      })
    )
  })
);
var applicationResponse = new SchemaValidator(
  Type3.Array(
    Type3.Object({
      id: Type3.Number(),
      name: Type3.String(),
      processName: Type3.Array(Type3.String()),
      iconSvg: Type3.String(),
      type: Type3.Union([
        Type3.Literal("Browser"),
        Type3.Literal("Communication"),
        Type3.Literal("Screen Sharing"),
        Type3.Literal("Other")
      ]),
      createdAt: Type3.String(),
      updatedAt: Type3.String()
    })
  )
);
var extensionResponse = new SchemaValidator(
  Type3.Array(
    Type3.Object({
      id: Type3.Number(),
      extensionId: Type3.String(),
      extensionName: Type3.String(),
      iconSvg: Type3.String(),
      type: Type3.Union([Type3.Literal("Writing Tools"), Type3.Literal("Screen Capture Tools"), Type3.Literal("Other")]),
      createdAt: Type3.String(),
      updatedAt: Type3.String()
    })
  )
);
var schema_validators_default2 = {
  verityOptions,
  applicationResponse,
  extensionResponse
};

// src/schemas/typebox/assessment/schema-validators.ts
var assessmentInfoType = Type4.Object({
  id: Type4.Number(),
  courseId: Type4.Number(),
  quizId: Type4.String(),
  quizInfo: OptionalOrNull(
    Type4.Union([
      Type4.String(),
      Type4.Intersect([
        Type4.Object({
          name: OptionalOrNull(Type4.String())
        }),
        Type4.Record(Type4.String(), Type4.Any())
      ])
    ])
  ),
  isDeleted: Type4.Boolean(),
  createdAt: OptionalOrNull(Type4.Union([Type4.Number(), Type4.String()])),
  updatedAt: OptionalOrNull(Type4.Union([Type4.Number(), Type4.String()])),
  sourcesLastScanned: Type4.Union([Type4.String(), Type4.Null()])
});
var baseQuizQuestionType = Type4.Object({
  id: Type4.Optional(Type4.Number()),
  questionText: Type4.String(),
  questionOrder: Type4.Number(),
  questionType: Type4.Union([
    Type4.Literal("MultipleChoice"),
    Type4.Literal("TrueFalse"),
    Type4.Literal("FillInTheBlank"),
    Type4.Literal("Matching"),
    Type4.Literal("FileUpload")
  ]),
  correctionPoints: Type4.Number()
});
var choiceAnswer = new SchemaValidator(Type4.Array(Type4.Number()));
var fitbAnswer = new SchemaValidator(Type4.Record(Type4.Number(), Type4.String()));
var matchingAnswer = new SchemaValidator(Type4.Record(Type4.String(), Type4.String()));
var quizAnswer = new SchemaValidator(Type4.Union([choiceAnswer.schema, fitbAnswer.schema, matchingAnswer.schema]));
var mcOption = new SchemaValidator(
  Type4.Object({
    text: Type4.String()
  })
);
var mcOptionInstructor = new SchemaValidator(
  Type4.Object({
    ...mcOption.schema.properties,
    weightage: Type4.Number()
  })
);
var tfOption = new SchemaValidator(
  Type4.Object({
    text: Type4.Union([Type4.Literal("True"), Type4.Literal("False")])
  })
);
var tfOptionInstructor = new SchemaValidator(
  Type4.Object({
    ...tfOption.schema.properties,
    weightage: Type4.Number()
  })
);
var fitbBlankAnswer = new SchemaValidator(
  Type4.Object({
    blankId: Type4.Number()
  })
);
var fitbBlankAnswerInstructor = new SchemaValidator(
  Type4.Object({
    ...fitbBlankAnswer.schema.properties,
    weightage: Type4.Number(),
    answers: Type4.Array(Type4.String())
  })
);
var matchingPair = new SchemaValidator(
  Type4.Object({
    premise: Type4.String(),
    response: Type4.String()
  })
);
var matchingPairInstructor = new SchemaValidator(
  Type4.Object({
    ...matchingPair.schema.properties,
    weightage: Type4.Number()
  })
);
var fileUploadOption = new SchemaValidator(
  Type4.Object({
    allowedFileTypes: Type4.Array(Type4.String())
  })
);
var studentOptionsUnion = new SchemaValidator(
  Type4.Union([
    Type4.Array(mcOption.schema),
    Type4.Array(tfOption.schema),
    Type4.Array(fitbBlankAnswer.schema),
    Type4.Array(matchingPair.schema),
    fileUploadOption.schema
  ])
);
var instructorOptionsUnion = new SchemaValidator(
  Type4.Union([
    Type4.Array(mcOptionInstructor.schema),
    Type4.Array(tfOptionInstructor.schema),
    Type4.Array(fitbBlankAnswerInstructor.schema),
    Type4.Array(matchingPairInstructor.schema),
    fileUploadOption.schema
  ])
);
var studentQuizQuestion = new SchemaValidator(
  Type4.Object({
    ...baseQuizQuestionType.properties,
    options: OptionalOrNull(studentOptionsUnion.schema)
  })
);
var instructorQuizQuestion = new SchemaValidator(
  Type4.Object({
    ...baseQuizQuestionType.properties,
    options: OptionalOrNull(instructorOptionsUnion.schema)
  })
);
var scoringStrategyType = new SchemaValidator(
  Type4.Union([Type4.Literal("highest"), Type4.Literal("latest"), Type4.Literal("first")])
);
var verityAssessmentType = Type4.Object({
  quizId: Type4.Number(),
  type: Type4.Union([Type4.Literal("quiz"), Type4.Literal("assignment")]),
  isPublished: Type4.Boolean(),
  syncGradebook: OptionalOrNull(Type4.Boolean()),
  startTime: Type4.String(),
  endTime: Type4.String(),
  allowLateSubmission: Type4.Boolean(),
  lateSubmissionDate: OptionalOrNull(Type4.String()),
  shuffleQuestions: OptionalOrNull(Type4.Boolean()),
  questionsPerPage: OptionalOrNull(Type4.Number()),
  numAttempts: Type4.Number(),
  showScoreOnSubmit: OptionalOrNull(Type4.Boolean()),
  duration: OptionalOrNull(Type4.Number()),
  description: OptionalOrNull(Type4.String()),
  moduleId: OptionalOrNull(Type4.String()),
  scoringStrategy: scoringStrategyType.schema
});
var studentVerityAssessmentType = Type4.Object({
  ...verityAssessmentType.properties,
  questions: OptionalOrNull(Type4.Array(studentQuizQuestion.schema))
});
var instructorVerityAssessmentType = Type4.Object({
  ...verityAssessmentType.properties,
  questions: OptionalOrNull(Type4.Array(instructorQuizQuestion.schema))
});
var verityAssessment = new SchemaValidator(Type4.Union([studentVerityAssessmentType, instructorVerityAssessmentType]));
var assessmentInfo = new SchemaValidator(assessmentInfoType);
var assessmentInfoArray = new SchemaValidator(Type4.Array(assessmentInfoType));
var assessmentInfoList = new SchemaValidator(
  Type4.Array(
    Type4.Intersect([
      assessmentInfoType,
      Type4.Object({
        hasDecoySite: Type4.Boolean(),
        proctoringOptions: OptionalOrNull(
          Type4.Object({
            enabled: OptionalOrNull(Type4.Boolean()),
            isLiveProctored: OptionalOrNull(Type4.Boolean()),
            isLivePopIn: OptionalOrNull(Type4.Boolean()),
            enablePostReview: OptionalOrNull(Type4.Boolean()),
            isExtension: OptionalOrNull(Type4.Boolean()),
            isLockdown: OptionalOrNull(Type4.Boolean()),
            isMobile: OptionalOrNull(Type4.Boolean()),
            chromeOsAccess: chromeOsAccessType,
            requiresIncognito: OptionalOrNull(Type4.Boolean()),
            candidateInterviewOptions: OptionalOrNull(candidateInterviewOptionsGetType)
          })
        ),
        proctoringAssessmentConfiguration: OptionalOrNull(
          Type4.Object(
            {
              thirdPartyAssessmentOption: OptionalOrNull(
                Type4.Object({
                  thirdPartyUrl: OptionalOrNull(Type4.String()),
                  password: OptionalOrNull(Type4.String()),
                  thirdPartyPlatformId: OptionalOrNull(Type4.Number())
                })
              )
            },
            { additionalProperties: true }
          )
        ),
        verityAssessment: OptionalOrNull(verityAssessment.schema)
      })
    ])
  )
);
var lmsAssessmentInfo = new SchemaValidator(
  Type4.Object({
    launchLink: OptionalOrNull(Type4.String())
  })
);
var standaloneStudent = Type4.Object({
  userId: Type4.Number(),
  firstName: Type4.String(),
  lastName: Type4.String(),
  email: Type4.String()
});
var standaloneStudentList = new SchemaValidator(Type4.Array(standaloneStudent));
var d2lContentQuizzes = new SchemaValidator(
  Type4.Array(
    Type4.Object({
      id: Type4.Number(),
      quizId: Type4.String()
    })
  )
);
var d2lContentPlatform = new SchemaValidator(Type4.Number());
var verityEnabledAssessment = new SchemaValidator(
  Type4.Object({
    quizId: Type4.String()
  })
);
var verityEnabledAssessments = new SchemaValidator(Type4.Array(verityEnabledAssessment.schema));
var lmsThirdPartyQuiz = new SchemaValidator(
  Type4.Object({
    quizId: Type4.String(),
    platformId: Type4.Union([Type4.Number(), Type4.Null()])
  })
);
var lmsThirdPartyQuizzes = new SchemaValidator(Type4.Array(lmsThirdPartyQuiz.schema));
var lmsThirdPartyQuizWithActivityUrl = new SchemaValidator(
  Type4.Intersect([
    lmsThirdPartyQuiz.schema,
    Type4.Object({
      activityUrl: Type4.Union([Type4.String(), Type4.Null()])
    })
  ])
);
var lmsThirdPartyQuizzesWithActivityUrl = new SchemaValidator(Type4.Array(lmsThirdPartyQuizWithActivityUrl.schema));
var suffixUpdateResult = new SchemaValidator(
  Type4.Object({
    ok: Type4.Boolean(),
    exists: Type4.Boolean(),
    newName: Type4.Union([Type4.String(), Type4.Null()])
  })
);
var assessmentMonthlyCountType = Type4.Object({
  count: Type4.Number(),
  monthlyCounts: Type4.Array(Type4.Number())
});
var assessmentMonthlyCountList = new SchemaValidator(
  Type4.Object({
    liveAssessments: assessmentMonthlyCountType,
    nonLiveAssessments: assessmentMonthlyCountType
  })
);
var validate = new SchemaValidator(
  Type4.Object({
    didValidate: Type4.Boolean(),
    doPasswordsMatch: Type4.Boolean(),
    isPasswordRequired: Type4.Boolean()
  })
);
var synchronize = new SchemaValidator(
  Type4.Object({
    didSynchronize: Type4.Boolean(),
    doPasswordsMatch: Type4.Boolean(),
    isPasswordRequired: Type4.Boolean()
  })
);
var assessmentQuestionType = Type4.Object({
  id: Type4.Number(),
  createdAt: Type4.String(),
  updatedAt: Type4.String(),
  assessmentId: Type4.Number(),
  lmsProvidedQuestionId: Type4.Union([Type4.String(), Type4.Null()]),
  title: Type4.Union([Type4.String(), Type4.Null()]),
  bodyHtml: Type4.Union([Type4.String(), Type4.Null()]),
  bodyText: Type4.Union([Type4.String(), Type4.Null()]),
  sources: Type4.Union([Type4.Array(Type4.String()), Type4.Null()]),
  numSources: Type4.Number(),
  hasDecoySitePost: Type4.Boolean(),
  isDeleted: Type4.Boolean()
});
var assessmentQuestion = new SchemaValidator(assessmentQuestionType);
var assessmentQuestions = new SchemaValidator(Type4.Array(assessmentQuestionType));
var questionSources = new SchemaValidator(
  Type4.Object({
    sources: Type4.Array(
      Type4.Object({
        url: Type4.String(),
        email: Type4.Union([Type4.String(), Type4.Null()])
      })
    ),
    numSources: Type4.Number()
  })
);
var assessmentTypeInput = new SchemaValidator(
  Type4.Union([Type4.Literal("canvas-new-quiz"), Type4.Literal("assignment"), Type4.Literal("canvas-quiz")])
);
var schema_validators_default3 = {
  assessmentInfo,
  assessmentInfoArray,
  assessmentInfoList,
  lmsAssessmentInfo,
  standaloneStudentList,
  d2lContentQuizzes,
  d2lContentPlatform,
  lmsThirdPartyQuiz,
  lmsThirdPartyQuizzes,
  lmsThirdPartyQuizWithActivityUrl,
  lmsThirdPartyQuizzesWithActivityUrl,
  verityEnabledAssessment,
  verityEnabledAssessments,
  suffixUpdateResult,
  assessmentMonthlyCountList,
  validate,
  synchronize,
  assessmentQuestion,
  assessmentQuestions,
  questionSources,
  verityAssessment,
  instructorQuizQuestion,
  studentQuizQuestion,
  choiceAnswer,
  fitbAnswer,
  matchingAnswer,
  quizAnswer,
  mcOption,
  mcOptionInstructor,
  tfOption,
  tfOptionInstructor,
  fitbBlankAnswer,
  fitbBlankAnswerInstructor,
  matchingPair,
  matchingPairInstructor,
  fileUploadOption,
  assessmentTypeInput
};

// src/schemas/typebox/authentication/schema-validators.ts
import { Type as Type5 } from "@sinclair/typebox";
var authenticated = new SchemaValidator(
  Type5.Object({
    authenticated: Type5.Boolean()
  })
);
var accessCode = new SchemaValidator(
  Type5.Object({
    code: Type5.String()
  })
);
var accessControlAuthCode = new SchemaValidator(
  Type5.Object({
    authCode: Type5.String()
  })
);
var refreshTokenInfo = new SchemaValidator(
  Type5.Object({
    refreshToken: Type5.String(),
    accountId: Type5.String(),
    currentUserId: Type5.String()
  })
);
var accountType = Type5.Object({
  id: Type5.String(),
  email: OptionalOrNull(Type5.String()),
  currentUserId: OptionalOrNull(Type5.String()),
  userIds: Type5.Array(Type5.String()),
  twoFactorVerified: OptionalOrNull(Type5.Boolean())
});
var account = new SchemaValidator(accountType);
var accounts = new SchemaValidator(PaginatedResults(accountType, "accounts"));
var getAccountPortals = new SchemaValidator(
  PaginatedResults(
    Type5.Object({
      accountId: Type5.String(),
      userId: Type5.String(),
      role: Type5.String(),
      instituteId: Type5.String(),
      instituteName: OptionalOrNull(Type5.String()),
      institutePlatform: OptionalOrNull(Type5.String()),
      instituteOrigin: OptionalOrNull(Type5.String()),
      courseId: Type5.String(),
      lmsCourseId: OptionalOrNull(Type5.String()),
      courseCode: OptionalOrNull(Type5.String()),
      courseName: OptionalOrNull(Type5.String())
    }),
    "entries"
  )
);
var getAccountInstitutes = new SchemaValidator(
  PaginatedResults(
    Type5.Object({
      hostname: OptionalOrNull(Type5.String()),
      id: Type5.String(),
      name: OptionalOrNull(Type5.String()),
      origin: OptionalOrNull(Type5.String()),
      platform: OptionalOrNull(Type5.String())
    }),
    "institutes"
  )
);
var schema_validators_default4 = {
  authenticated,
  accessCode,
  accessControlAuthCode,
  refreshTokenInfo,
  account,
  accounts,
  getAccountPortals,
  getAccountInstitutes
};

// src/schemas/typebox/basic-auth/schema-validators.ts
import { Type as Type6 } from "@sinclair/typebox";
var createAccount = new SchemaValidator(
  Type6.Object({
    id: Type6.String(),
    email: Type6.String(),
    enabled: Type6.Boolean(),
    accountNonLocked: Type6.Boolean(),
    currentUserId: OptionalOrNull(Type6.String()),
    userIds: Type6.Array(Type6.String())
  })
);
var login = new SchemaValidator(
  Type6.Union([
    Type6.Object({
      refreshToken: Type6.String(),
      accountId: Type6.String(),
      mfaRequired: Type6.Literal(false)
    }),
    Type6.Object({
      mfaChallengeToken: Type6.String(),
      mfaRequired: Type6.Literal(true),
      mfaEnabled: Type6.Literal(true)
    }),
    Type6.Object({
      mfaChallengeToken: Type6.String(),
      mfaRequired: Type6.Literal(true),
      mfaEnabled: Type6.Literal(false),
      qrCodeUrl: Type6.String(),
      twoFactorSecret: Type6.String()
    })
  ])
);
var verifyEmail = new SchemaValidator(
  Type6.Object({
    accountId: Type6.String(),
    emailVerificationToken: Type6.String()
  })
);
var resetPassword = new SchemaValidator(
  Type6.Object({
    accountId: Type6.String(),
    passwordRestToken: Type6.String(),
    password: Type6.String()
  })
);
var verifyTwoFactor = new SchemaValidator(
  Type6.Object({
    refreshToken: Type6.String(),
    accountId: Type6.String()
  })
);
var twoFactorStatus = new SchemaValidator(
  Type6.Object({
    twoFactorVerified: Type6.Boolean()
  })
);
var verifiedTwoFactorAccounts = new SchemaValidator(Type6.Array(Type6.String()));
var schema_validators_default5 = {
  createAccount,
  login,
  verifyEmail,
  resetPassword,
  verifyTwoFactor,
  twoFactorStatus,
  verifiedTwoFactorAccounts
};

// src/schemas/typebox/course/schema-validators.ts
import { Type as Type7 } from "@sinclair/typebox";
var courseInfoType = Type7.Object({
  id: Type7.Number(),
  instituteId: Type7.Number(),
  courseId: Type7.String(),
  code: Type7.Optional(Type7.Union([Type7.String(), Type7.Null()])),
  name: Type7.Optional(Type7.Union([Type7.String(), Type7.Null()])),
  isBlackboardUltra: Type7.Optional(Type7.Union([Type7.Boolean(), Type7.Null()])),
  verityEnabled: Type7.Boolean(),
  accessControlUuid: Type7.String()
});
var courseInfo = new SchemaValidator(courseInfoType);
var courseInfoList = new SchemaValidator(Type7.Array(courseInfoType));
var accessControlCourseInfoType = Type7.Object({
  id: Type7.String(),
  instituteId: Type7.String(),
  code: OptionalOrNull(Type7.String()),
  name: OptionalOrNull(Type7.String())
});
var accessControlCourseInfo = new SchemaValidator(accessControlCourseInfoType);
var courseId = new SchemaValidator(
  Type7.Object({
    id: Type7.Number()
  })
);
var courseCount = new SchemaValidator(
  Type7.Object({
    totalElements: Type7.Number()
  })
);
var geofenceLocationType = Type7.Object({
  longitude: Type7.Number(),
  latitude: Type7.Number(),
  radius: Type7.Number(),
  name: Type7.String(),
  isMetric: Type7.Boolean()
});
var courseSettings = new SchemaValidator(
  Type7.Object({
    geofenceLocations: Type7.Array(geofenceLocationType)
  })
);
var modulesType = Type7.Object({
  id: Type7.String(),
  name: Type7.String()
});
var courseRootModules = new SchemaValidator(
  Type7.Object({
    modules: Type7.Array(modulesType)
  })
);
var module = new SchemaValidator(modulesType);
var courseRootSections = new SchemaValidator(
  Type7.Object({
    sections: Type7.Array(modulesType)
  })
);
var section = new SchemaValidator(modulesType);
var schema_validators_default6 = {
  courseInfo,
  courseInfoList,
  accessControlCourseInfo,
  courseId,
  courseCount,
  courseSettings,
  courseRootModules,
  module,
  courseRootSections,
  section
};

// src/schemas/typebox/download/schema-validators.ts
import { Type as Type8 } from "@sinclair/typebox";
var lockdownDownloadPath = new SchemaValidator(
  Type8.Object({
    path: Type8.String(),
    files: Type8.Array(
      Type8.Object({
        url: Type8.String(),
        size: Type8.Number()
      })
    )
  })
);
var requestProctoringSessionDownloadResponse = new SchemaValidator(
  Type8.Object({
    ready: Type8.Boolean(),
    emailDestination: Type8.String()
  })
);
var schema_validators_default7 = {
  lockdownDownloadPath,
  requestProctoringSessionDownloadResponse
};

// src/schemas/typebox/feedback/schema-validators.ts
import { Type as Type9 } from "@sinclair/typebox";
var satisfactionType = new SchemaValidator(
  Type9.Union([Type9.Literal("poor"), Type9.Literal("satisfied"), Type9.Literal("good"), Type9.Literal("excellent")])
);
var categoryType = new SchemaValidator(
  Type9.Union([Type9.Literal("suggestion"), Type9.Literal("bug"), Type9.Literal("comment"), Type9.Literal("other")])
);
var schema_validators_default8 = {
  satisfactionType,
  categoryType
};

// src/schemas/typebox/installation/schema-validators.ts
import { Type as Type10 } from "@sinclair/typebox";
var installation = new SchemaValidator(
  Type10.Object({
    id: Type10.String(),
    platform: Type10.Union([Type10.Literal("extension"), Type10.Literal("lockdown"), Type10.Literal("mobile")]),
    version: Type10.String(),
    fingerprint: Type10.String(),
    details: Type10.Object({})
  })
);
var schema_validators_default9 = {
  installation
};

// src/schemas/typebox/institute/schema-validators.ts
import { Type as Type12 } from "@sinclair/typebox";

// src/schemas/typebox/proctoring-profile/schema-validators.ts
import { Type as Type11 } from "@sinclair/typebox";
var recordingModeType2 = Type11.Union([Type11.Literal("off"), Type11.Literal("normal"), Type11.Literal("strict")]);
var proctoringOptionProfileType = Type11.Union([
  Type11.Literal("institute"),
  Type11.Literal("course"),
  Type11.Literal("user"),
  Type11.Literal("assessment"),
  Type11.Literal("preset")
]);
function OptionalOrNull2(type) {
  return Type11.Optional(Type11.Union([Type11.Null(), type]));
}
var proctoringOptionType = Type11.Object({
  enforceLockdown: Type11.Boolean(),
  enforceMobile: Type11.Boolean(),
  isExtension: Type11.Boolean(),
  isLockdown: Type11.Boolean(),
  isMobile: Type11.Boolean(),
  isChromeOs: Type11.Boolean(),
  videoRecordingMode: recordingModeType2,
  secondaryVideoRecordingMode: recordingModeType2,
  audioRecordingMode: recordingModeType2,
  recordScreen: Type11.Boolean(),
  recordWebTraffic: Type11.Boolean(),
  detectSidePanel: Type11.Boolean(),
  excludedWebTrafficRecordingUrls: OptionalOrNull2(Type11.Array(Type11.String())),
  recordClipboard: Type11.Boolean(),
  recordInput: Type11.Boolean(),
  oneScreenEnforcementMode: recordingModeType2,
  disableNewTab: Type11.Boolean(),
  closeOpenTabs: Type11.Boolean(),
  tabWhiteList: OptionalOrNull2(Type11.Array(Type11.String())),
  tabBlockList: OptionalOrNull2(Type11.Array(Type11.String())),
  keyboardShortcutBlockList: OptionalOrNull2(Type11.Array(Type11.String())),
  disableClipboardMode: Type11.Union([Type11.Literal("off"), Type11.Literal("tab"), Type11.Literal("system")]),
  enableGuidedAccessMode: Type11.Boolean(),
  restrictHandoffMode: recordingModeType2,
  disableSpellcheck: Type11.Boolean(),
  disablePrinting: Type11.Boolean(),
  disableRightClick: Type11.Boolean(),
  extensionBlockMode: recordingModeType2,
  allowedExtensionsList: OptionalOrNull2(Type11.Array(Type11.String())),
  logInstalledExtensions: Type11.Boolean(),
  disableDownloadFiles: Type11.Boolean(),
  hideOtherWindows: Type11.Boolean(),
  showRecordingPanel: Type11.Boolean(),
  idVerification: Type11.Boolean(),
  idVerificationEnableAi: Type11.Boolean(),
  faceTrackingMode: recordingModeType2,
  objectDetectionMode: recordingModeType2,
  applicationBlockMode: recordingModeType2,
  blockWindowedApplications: Type11.Boolean(),
  applicationBlockList: OptionalOrNull2(Type11.Array(Type11.String())),
  allowedApplicationsList: OptionalOrNull2(Type11.Array(Type11.String())),
  blockVirtualMachines: Type11.Boolean(),
  recordApplicationsActivity: Type11.Boolean(),
  scanRoom: Type11.Boolean(),
  quietEnvironment: Type11.Boolean(),
  enableCalculator: Type11.Union([Type11.Literal("off"), Type11.Literal("scientific"), Type11.Literal("standard")]),
  enableWhiteboard: Type11.Boolean(),
  enableCodeEditor: Type11.Boolean(),
  codeEditorRoomId: OptionalOrNull2(Type11.Array(Type11.String(), { maxItems: 1 })),
  uploadScratchNotes: Type11.Boolean(),
  idVerificationMode: recordingModeType2,
  restrictDevices: Type11.Boolean(),
  audioTranscription: Type11.Boolean(),
  flaggedKeywords: Type11.Union([
    Type11.Null(),
    Type11.Array(
      Type11.Object({
        keyword: Type11.String(),
        level: Type11.Optional(Type11.Number())
      })
    )
  ]),
  uploadSignature: Type11.Boolean(),
  enableGeofence: Type11.Boolean(),
  geofenceLocations: OptionalOrNull2(
    Type11.Array(
      Type11.Object({
        longitude: Type11.Number(),
        latitude: Type11.Number(),
        radius: Type11.Number(),
        name: Type11.String(),
        isMetric: Type11.Boolean()
      })
    )
  ),
  disableVirtualCamera: Type11.Boolean()
});
var proctoringOptionProfile = Type11.Object({
  id: Type11.Number(),
  name: Type11.Union([Type11.Null(), Type11.String()]),
  type: proctoringOptionProfileType,
  proctoringOption: Type11.Object({
    ...proctoringOptionType.properties
  }),
  instituteProfile: OptionalOrNull2(
    Type11.Object({
      id: Type11.Number(),
      enforced: Type11.Boolean(),
      instituteId: Type11.Number(),
      proctoringOptionProfileId: Type11.Number()
    })
  ),
  courseProfile: OptionalOrNull2(
    Type11.Object({
      id: Type11.Number(),
      courseId: Type11.Number(),
      proctoringOptionProfileId: Type11.Number()
    })
  ),
  userProfile: OptionalOrNull2(
    Type11.Object({
      id: Type11.Number(),
      userId: Type11.Number(),
      proctoringOptionProfileId: Type11.Number()
    })
  )
});
var profiles = new SchemaValidator(Type11.Array(proctoringOptionProfile));
var enforced = new SchemaValidator(Type11.Object({ enforced: Type11.Boolean() }));
var schema_validators_default10 = {
  profile: new SchemaValidator(proctoringOptionProfile),
  profileOrNull: new SchemaValidator(Type11.Union([Type11.Null(), proctoringOptionProfile])),
  profiles,
  enforced,
  proctoringOption: new SchemaValidator(proctoringOptionType)
};

// src/schemas/typebox/institute/schema-validators.ts
var accessControlInstituteId = new SchemaValidator(Type12.String());
var instituteInfo = new SchemaValidator(
  Type12.Object({
    id: Type12.Integer(),
    uuid: Type12.String(),
    name: Type12.String(),
    origin: OptionalOrNull(Type12.String()),
    lms: OptionalOrNull(Type12.String())
  })
);
var instituteLanguage = new SchemaValidator(
  Type12.Object({
    language: Type12.String()
  })
);
var verityInstituteSettings = new SchemaValidator(
  Type12.Object({
    allowLiveProctoring: Type12.Boolean(),
    liveProctoringResetableCredits: OptionalOrNull(Type12.Number()),
    liveProctoringCreditsResetDate: OptionalOrNull(Type12.String()),
    liveProctoringOneTimeCredits: Type12.Number(),
    allowLivePopIn: Type12.Boolean(),
    livePopInResetableCredits: OptionalOrNull(Type12.Number()),
    livePopInCreditsResetDate: OptionalOrNull(Type12.String()),
    livePopInOneTimeCredits: Type12.Number(),
    allowLivePopInPostReview: Type12.Boolean(),
    allowStandaloneMode: Type12.Boolean(),
    allowAiStrictMode: Type12.Boolean(),
    allowDemoMode: Type12.Boolean(),
    allowExtensionPlatform: Type12.Boolean(),
    allowLockdownPlatform: Type12.Boolean(),
    allowMobilePlatform: Type12.Boolean(),
    showAllAssessments: Type12.Boolean(),
    liteMode: Type12.Boolean(),
    liteModeViewReports: Type12.Boolean(),
    salesforceId: OptionalOrNull(Type12.String()),
    cleanupEnabled: Type12.Boolean(),
    cutoffDate: OptionalOrNull(Type12.String()),
    cleanupFrequency: OptionalOrNull(Type12.String()),
    lastCleanupAt: OptionalOrNull(Type12.String()),
    allowVerityAssessment: Type12.Boolean()
  })
);
var integrated = new SchemaValidator(
  Type12.Object({
    integrated: Type12.Boolean()
  })
);
var CourseSettings = new SchemaValidator(
  Type12.Object({
    "CourseSetting-allowStopRecording": Type12.Boolean(),
    "InstituteSetting-allowStopRecording": Type12.Boolean(),
    "CourseEmailSetting-courseEmailSetting": Type12.Boolean(),
    "InstituteEmailSetting-instituteEmailSetting": Type12.Boolean(),
    "Info-instituteEmailCount": Type12.String()
  })
);
var disabledProctoringOptionType = Type12.Array(Type12.String());
var instituteDisabledProctoringOptions = new SchemaValidator(disabledProctoringOptionType);
var instituteAllowStrictMode = new SchemaValidator(
  Type12.Object({
    allowStrictMode: Type12.Boolean(),
    allowAiStrictMode: Type12.Boolean()
  })
);
var lmsAccounts = new SchemaValidator(
  Type12.Array(
    Type12.Object({
      id: Type12.Integer(),
      accountName: Type12.String(),
      lmsAccountId: Type12.String(),
      parentLmsAccountId: OptionalOrNull(Type12.String()),
      rootLmsAccountId: OptionalOrNull(Type12.String()),
      lmsAccountState: OptionalOrNull(Type12.String()),
      verityEnabled: Type12.Boolean()
    })
  )
);
var instituteScopeMode = new SchemaValidator(
  Type12.Object({
    scopeMode: Type12.Union([
      Type12.Literal("allCourses"),
      Type12.Literal("selectedAccounts"),
      Type12.Literal("selectedCourses")
    ]),
    allAccounts: Type12.Array(
      Type12.Object({
        id: Type12.Integer(),
        accountName: Type12.String(),
        lmsAccountId: Type12.String(),
        parentLmsAccountId: OptionalOrNull(Type12.String()),
        verityEnabled: Type12.Boolean()
      })
    ),
    selectedCourses: Type12.Array(
      Type12.Object({
        id: Type12.Integer(),
        courseId: Type12.String(),
        courseName: Type12.String(),
        courseUrl: Type12.String()
      })
    )
  })
);
var instituteSuffix = new SchemaValidator(
  Type12.Object({
    suffix: Type12.Union([Type12.String(), Type12.Null()])
  })
);
var latestReport = new SchemaValidator(
  Type12.Object(
    {
      month: Type12.Number(),
      year: Type12.Number(),
      title: Type12.String(),
      summary: Type12.String(),
      topMetrics: Type12.Array(
        Type12.Object({
          key: Type12.String(),
          type: Type12.Optional(Type12.String()),
          currentValue: Type12.String(),
          previousValue: Type12.Optional(Type12.String()),
          percentChange: Type12.Optional(Type12.String()),
          imageUrl: Type12.Optional(Type12.String()),
          texts: Type12.Array(Type12.String())
        })
      )
    },
    { additionalProperties: true }
  )
);
var proctoringOptionKey = new SchemaValidator(Type12.KeyOf(proctoringOptionProfile.properties.proctoringOption));
var instituteId = new SchemaValidator(
  Type12.Object({
    id: Type12.Number()
  })
);
var accessControlInstitute = new SchemaValidator(
  Type12.Object({
    id: Type12.String(),
    name: OptionalOrNull(Type12.String()),
    origin: OptionalOrNull(Type12.String()),
    platform: OptionalOrNull(Type12.String()),
    subdomain: OptionalOrNull(Type12.String()),
    hostnames: Type12.Array(Type12.String()),
    product: OptionalOrNull(Type12.Union([Type12.Literal("candidate"), Type12.Literal("verity")])),
    mfaRequired: OptionalOrNull(Type12.Boolean())
  })
);
var apiKey = new SchemaValidator(
  Type12.Object({
    id: Type12.Number(),
    keyId: OptionalOrNull(Type12.String()),
    platform: OptionalOrNull(Type12.String()),
    origin: OptionalOrNull(Type12.String()),
    apiUrl: OptionalOrNull(Type12.String())
  })
);
var thirdPartyPlatformRoster = new SchemaValidator(
  Type12.Object({
    selectedPlatforms: Type12.Array(
      Type12.Object({
        platformId: Type12.Number(),
        platformName: Type12.String()
      })
    ),
    unselectedPlatforms: Type12.Array(
      Type12.Object({
        platformId: Type12.Number(),
        platformName: Type12.String()
      })
    )
  })
);
var verityEnabled = new SchemaValidator(
  Type12.Object({
    verityEnabled: Type12.Boolean()
  })
);
var apiKeys = new SchemaValidator(Type12.Object({ apiKeys: Type12.Array(apiKey.schema) }));
var hostnames = new SchemaValidator(Type12.Object({ hostnames: Type12.Array(Type12.String()) }));
var thirdPartyIntegrations = new SchemaValidator(thirdPartyPlatformRoster.schema);
var instituteProctoringAccommodation = new SchemaValidator(
  Type12.Array(
    Type12.Object({
      userId: Type12.Integer(),
      accommodationNotes: OptionalOrNull(Type12.String()),
      proctoringOptionProfileId: OptionalOrNull(Type12.Integer())
    })
  )
);
var ruleType = Type12.Intersect([
  Type12.Union([
    Type12.Object({
      scope: Type12.Literal("global")
    }),
    Type12.Object({
      scope: Type12.Literal("lmsProvidedCourseId"),
      scopeValue: Type12.String()
    }),
    Type12.Object({
      scope: Type12.Literal("courseNamePrefix"),
      scopeValue: Type12.String()
    })
  ]),
  Type12.Object({
    type: Type12.Literal("editConfiguration"),
    details: OptionalOrNull(Type12.Unknown()),
    enabled: Type12.Boolean()
  })
]);
var rulesResponse = new SchemaValidator(Type12.Array(ruleType));
var usageHours = new SchemaValidator(Type12.Object({ hours: Type12.Number() }));
var instituteSettings = new SchemaValidator(
  Type12.Object({
    suffix: OptionalOrNull(Type12.String()),
    allowStrictMode: Type12.Boolean(),
    lockdownRequireManagedGuestSession: Type12.Boolean(),
    managedGuestSessionRequireIncognito: Type12.Boolean(),
    flaggedKeywords: Type12.Union([
      Type12.Null(),
      Type12.Array(
        Type12.Object({
          keyword: Type12.String(),
          level: Type12.Optional(Type12.Number())
        })
      )
    ]),
    allowQuizAttemptOnChrome: Type12.Boolean(),
    allowQuizAttemptOnFirefox: Type12.Boolean(),
    allowQuizAttemptOnSafari: Type12.Boolean(),
    disabledProctoringOptions: Type12.Union([Type12.Null(), disabledProctoringOptionType]),
    recordingMaxAgeMonths: Type12.Integer()
  })
);
var agreementUrl = new SchemaValidator(
  Type12.Object({
    url: Type12.Optional(Type12.String())
  })
);
var schema_validators_default11 = {
  accessControlInstituteId,
  instituteInfo,
  verityInstituteSettings,
  integrated,
  CourseSettings,
  instituteLanguage,
  instituteDisabledProctoringOptions,
  instituteAllowStrictMode,
  instituteScopeMode,
  lmsAccounts,
  instituteSuffix,
  latestReport,
  proctoringOptionKey,
  instituteId,
  accessControlInstitute,
  apiKey,
  apiKeys,
  verityEnabled,
  hostnames,
  thirdPartyIntegrations,
  instituteProctoringAccommodation,
  rulesResponse,
  usageHours,
  instituteSettings,
  agreementUrl
};

// src/schemas/typebox/integration/schema-validators.ts
import { Type as Type13 } from "@sinclair/typebox";
var integrationStatus = new SchemaValidator(
  Type13.Object({
    active: Type13.Boolean()
  })
);
var schema_validators_default12 = {
  integrationStatus
};

// src/schemas/typebox/live/schema-validators.ts
import { Type as Type14 } from "@sinclair/typebox";
var liveSession = new SchemaValidator(
  Type14.Object({
    liveSessionId: Type14.String()
  })
);
var proctorGroup = Type14.Object({
  id: Type14.Number(),
  name: Type14.String(),
  ownerInstituteId: Type14.String(),
  createdAt: Type14.String(),
  updatedAt: Type14.String(),
  allowedInstitutes: Type14.Array(
    Type14.Object({
      instituteId: Type14.String(),
      minHoursNotice: Type14.Number(),
      trackCancellationHoursBefore: Type14.Number(),
      trackCancellationMessage: Type14.String(),
      autoCancelEmptyHoursBefore: OptionalOrNull(Type14.Number())
    })
  )
});
var liveSessionUser = Type14.Object({
  liveSessionId: Type14.String(),
  userId: Type14.String(),
  role: Type14.Union([Type14.Literal("proctor"), Type14.Literal("student")]),
  createdAt: Type14.String(),
  updatedAt: Type14.String()
});
var liveSessionUserValidator = new SchemaValidator(liveSessionUser);
var liveSessionUserSession = Type14.Object({
  id: Type14.String(),
  userId: Type14.String(),
  liveSessionId: Type14.String(),
  role: Type14.Union([Type14.Literal("proctor"), Type14.Literal("student")]),
  connectionState: Type14.Union([
    Type14.Literal("connecting"),
    Type14.Literal("connected"),
    Type14.Literal("reconnecting"),
    Type14.Literal("failed")
  ])
});
var liveSessionUserSessionValidator = new SchemaValidator(liveSessionUserSession);
var liveSessionInvitation = Type14.Object({
  liveSessionId: Type14.String(),
  proctorGroupId: Type14.Number(),
  state: Type14.Object({
    selectedProctorId: OptionalOrNull(Type14.String()),
    firstJoinedAt: OptionalOrNull(Type14.String()),
    cancelledAt: OptionalOrNull(Type14.String())
  }),
  createdAt: Type14.String(),
  updatedAt: Type14.String()
});
var liveSessionInvitations = new SchemaValidator(Type14.Array(liveSessionInvitation));
var liveSessionNote = Type14.Object({
  id: Type14.String(),
  liveSessionId: Type14.String(),
  student: Type14.String(),
  edits: Type14.Array(
    Type14.Object({
      id: Type14.String(),
      editor: Type14.String(),
      content: Type14.String(),
      timestamp: Type14.Number()
    })
  )
});
var liveSessionNotes = new SchemaValidator(Type14.Array(liveSessionNote));
var assessmentLiveSession = {
  id: Type14.String(),
  instituteId: OptionalOrNull(Type14.String()),
  courseId: OptionalOrNull(Type14.String()),
  assessmentId: OptionalOrNull(Type14.String()),
  name: Type14.String(),
  isPopIn: Type14.Boolean(),
  startTime: Type14.String(),
  proctorGuide: OptionalOrNull(Type14.String()),
  endTime: Type14.String(),
  capacity: Type14.Number(),
  registrationStartTime: OptionalOrNull(Type14.String()),
  registrationEndTime: OptionalOrNull(Type14.String()),
  createdAt: Type14.String(),
  updatedAt: Type14.String()
};
var liveSessionWithUsers = Type14.Object({
  ...assessmentLiveSession,
  users: Type14.Array(liveSessionUser)
});
var baseAssessmentLiveSession = new SchemaValidator(Type14.Object(assessmentLiveSession));
var singleLiveSession = new SchemaValidator(liveSessionWithUsers);
var liveSessionList = new SchemaValidator(PaginatedResults(Type14.Object(assessmentLiveSession)));
var liveSessionListWithUsers = new SchemaValidator(PaginatedResults(liveSessionWithUsers));
var courseLiveProctorInfo = new SchemaValidator(
  Type14.Array(
    Type14.Object({
      id: Type14.Number(),
      uuid: Type14.String(),
      name: Type14.String(),
      email: OptionalOrNull(Type14.String())
    })
  )
);
var instituteProctorGroups = new SchemaValidator(PaginatedResults(proctorGroup));
var registerLiveSessionInstituteUser = new SchemaValidator(liveSessionUser);
var deregisterLiveSessionInstituteUser = new SchemaValidator(liveSessionUser);
var registerLiveSessionProctorGroup = new SchemaValidator(OptionalOrNull(liveSessionInvitation));
var deregisterLiveSessionProctorGroup = new SchemaValidator(liveSessionInvitation);
var liveSessionInvitationValidator = new SchemaValidator(liveSessionInvitation);
var liveSessionLiveState = new SchemaValidator(
  Type14.Object({
    id: Type14.String(),
    userSessionIds: Type14.Array(Type14.String())
  })
);
var liveProctorGroup = new SchemaValidator(proctorGroup);
var liveProctorGroups = new SchemaValidator(Type14.Array(proctorGroup));
var schema_validators_default13 = {
  liveSession,
  singleLiveSession,
  liveSessionUser: liveSessionUserValidator,
  liveSessionUserSession: liveSessionUserSessionValidator,
  liveSessionInvitation: liveSessionInvitationValidator,
  liveSessionList,
  liveSessionListWithUsers,
  liveSessionInvitations,
  courseLiveProctorInfo,
  instituteProctorGroups,
  liveSessionNotes,
  baseAssessmentLiveSession,
  registerLiveSessionInstituteUser,
  deregisterLiveSessionInstituteUser,
  registerLiveSessionProctorGroup,
  deregisterLiveSessionProctorGroup,
  liveSessionLiveState,
  liveProctorGroup,
  liveProctorGroups
};

// src/schemas/typebox/lms-info/schema-validators.ts
import { Type as Type15 } from "@sinclair/typebox";
var lms = new SchemaValidator(
  Type15.Union([
    Type15.Literal("canvas"),
    Type15.Literal("moodle"),
    Type15.Literal("BlackboardLearn"),
    Type15.Literal("desire2learn")
  ])
);
var assessmentInfo2 = new SchemaValidator(
  Type15.Object({
    lms: Type15.Optional(lms.schema),
    hostname: Type15.Optional(Type15.String()),
    courseId: Type15.Optional(Type15.String()),
    quizId: Type15.String(),
    quizInfo: Type15.Optional(Type15.Record(Type15.String(), Type15.Any())),
    quizOther: Type15.Optional(Type15.Record(Type15.String(), Type15.Any()))
  })
);
var deleteAssessmentInfo = new SchemaValidator(
  Type15.Object({
    id: Type15.Number(),
    courseId: Type15.Number(),
    quizId: Type15.String(),
    quizInfo: Type15.Optional(Type15.Record(Type15.String(), Type15.Any())),
    other: Type15.Optional(Type15.Record(Type15.String(), Type15.Any())),
    isDeleted: Type15.Boolean(),
    createdAt: Type15.String(),
    updatedAt: Type15.String()
  })
);
var assessmentInfoAlternate = new SchemaValidator(
  Type15.Object({
    lms: lms.schema,
    hostname: Type15.String(),
    lmsProvidedCourseId: Type15.Optional(Type15.String()),
    lmsProvidedAssessmentId: Type15.String()
  })
);
var url = new SchemaValidator(Type15.String());
var instituteLmsInfo = new SchemaValidator(
  Type15.Object({
    id: Type15.Number(),
    instituteName: Type15.Union([Type15.Null(), Type15.String()]),
    origin: Type15.Optional(Type15.Union([Type15.Null(), Type15.String()])),
    lmsApiClientId: Type15.Optional(Type15.Union([Type15.Null(), Type15.String()]))
  })
);
var tokenExists = new SchemaValidator(
  Type15.Object({
    exists: Type15.Boolean()
  })
);
var tokenTestResults = new SchemaValidator(
  Type15.Array(
    Type15.Object({
      key: Type15.String(),
      relativePath: Type15.String(),
      requestType: Type15.String(),
      status: Type15.String()
    })
  )
);
var deleteResponse = new SchemaValidator(
  Type15.Object({
    success: Type15.Boolean(),
    lmsResponse: Type15.Optional(Type15.Unknown())
  })
);
var apiIntegrationInfo = new SchemaValidator(
  Type15.Object({
    course: OptionalOrNull(
      Type15.Object({
        edit: Type15.Boolean()
      })
    ),
    institute: OptionalOrNull(
      Type15.Object({
        edit: Type15.Boolean()
      })
    )
  })
);
var schema_validators_default14 = {
  lms,
  assessmentInfo: assessmentInfo2,
  url,
  instituteLmsInfo,
  tokenExists,
  tokenTestResults,
  deleteResponse,
  assessmentInfoAlternate,
  deleteAssessmentInfo,
  apiIntegrationInfo
};

// src/schemas/typebox/lti/schema-validators.ts
import { Type as Type16 } from "@sinclair/typebox";
var clientRegistrationType = Type16.Object({
  id: Type16.Integer(),
  linkageAttribute: OptionalOrNull(Type16.String()),
  linkUsersByEmail: Type16.Boolean()
});
var clientRegistration2 = new SchemaValidator(clientRegistrationType);
var clientRegistrations = new SchemaValidator(PaginatedResults(clientRegistrationType, "clientRegistrations"));
var schema_validators_default15 = {
  clientRegistration: clientRegistration2,
  clientRegistrations
};

// src/schemas/typebox/media/schema-validators.ts
import { Type as Type17 } from "@sinclair/typebox";
var getNextRecordingNumbers = new SchemaValidator(
  Type17.Object({
    screencapture: Type17.Number(),
    webcam: Type17.Number()
  })
);
var uploadRecording = new SchemaValidator(
  Type17.Object({
    url: Type17.String()
  })
);
var schema_validators_default16 = {
  getNextRecordingNumbers,
  uploadRecording
};

// src/schemas/typebox/oauth/schema-validators.ts
import { Type as Type18 } from "@sinclair/typebox";
var authorization = new SchemaValidator(
  Type18.Object({
    authorizationUrl: Type18.String()
  })
);
var accessToken = new SchemaValidator(
  Type18.Object({
    accessToken: Type18.String(),
    expiresIn: Type18.Number()
  })
);
var schema_validators_default17 = {
  authorization,
  accessToken
};

// src/schemas/typebox/payment/schema-validators.ts
var schema_validators_default18 = {};

// src/schemas/typebox/permission/schema-validators.ts
import { Type as Type19 } from "@sinclair/typebox";
var verityResultPermission = new SchemaValidator(
  Type19.Object({
    verified: Type19.Boolean()
  })
);
var portalPermission = new SchemaValidator(
  Type19.Array(
    Type19.Union([
      Type19.Literal("InstituteEdit"),
      Type19.Literal("CourseEdit"),
      Type19.Literal("VeritySettingsEdit"),
      Type19.Literal("CourseView"),
      Type19.Literal("LiveProctoringPrivilege"),
      Type19.Literal("LiveProctoring")
    ])
  )
);
var assessmentPermissions = new SchemaValidator(
  Type19.Object({
    assessment: Type19.Array(Type19.Union([Type19.Literal("create"), Type19.Literal("update"), Type19.Literal("read")]))
  })
);
var scopedPrivileges = new SchemaValidator(
  Type19.Record(
    Type19.String(),
    Type19.Array(
      Type19.Object({
        courseId: OptionalOrNull(Type19.String()),
        instituteId: OptionalOrNull(Type19.String()),
        resourceId: OptionalOrNull(Type19.Unknown())
      })
    )
  )
);
var schema_validators_default19 = {
  verityResultPermission,
  portalPermission,
  assessmentPermissions,
  scopedPrivileges
};

// src/schemas/typebox/platform-info/schema-validators.ts
import { Type as Type20 } from "@sinclair/typebox";
var platformInfo = new SchemaValidator(
  Type20.Object({
    platform: Type20.Union([
      Type20.Literal("none"),
      Type20.Literal("lockdown"),
      Type20.Literal("extension"),
      Type20.Literal("mobile")
    ]),
    version: OptionalOrNull(Type20.String()),
    versionSupported: Type20.Boolean()
  })
);
var versionSupported = new SchemaValidator(
  Type20.Object({
    versionSupported: Type20.Boolean()
  })
);
var schema_validators_default20 = {
  platformInfo,
  versionSupported
};

// src/schemas/typebox/proctoring-configuration/schema-validators.ts
import { Type as Type21 } from "@sinclair/typebox";
function OptionalOrNull3(type) {
  return Type21.Optional(Type21.Union([Type21.Null(), type]));
}
var proctoringAssessmentConfigurationType = Type21.Object({
  enabled: Type21.Boolean(),
  isLiveProctored: Type21.Boolean(),
  isLivePopIn: Type21.Boolean(),
  enablePostReview: Type21.Boolean(),
  password: Type21.Union([Type21.Null(), Type21.String()]),
  forceChromeOsManagedGuestSession: OptionalOrNull3(Type21.Boolean()),
  thirdPartyAssessmentOption: OptionalOrNull3(
    Type21.Object({
      thirdPartyUrl: OptionalOrNull3(Type21.String()),
      password: OptionalOrNull3(Type21.String()),
      thirdPartyPlatformId: OptionalOrNull3(Type21.Number())
    })
  ),
  proctoringOptionProfile
});
var proctoringAssessmentConfigurationV2 = new SchemaValidator(
  Type21.Intersect([
    proctoringAssessmentConfigurationType,
    Type21.Object({
      candidateInterviewOptions: OptionalOrNull3(candidateInterviewOptionsSaveType)
    })
  ])
);
var proctoringAssessmentConfigurationV2OrNull = new SchemaValidator(
  Type21.Union([
    Type21.Null(),
    Type21.Intersect([
      proctoringAssessmentConfigurationType,
      Type21.Object({
        candidateInterviewOptions: OptionalOrNull3(candidateInterviewOptionsGetType)
      })
    ])
  ])
);
var proctoringAssessmentConfigurationResponse = new SchemaValidator(
  Type21.Object({
    standaloneStudentInfo: OptionalOrNull3(
      Type21.Array(
        Type21.Object({
          id: Type21.Number(),
          userId: Type21.Number(),
          email: Type21.String(),
          firstName: Type21.String(),
          lastName: Type21.String()
        })
      )
    ),
    verityAssessmentInfo: OptionalOrNull3(schema_validators_default3.verityAssessment.schema),
    assessmentConfiguration: OptionalOrNull3(
      Type21.Object({
        id: Type21.Number(),
        lmsQuiz: OptionalOrNull3(schema_validators_default3.assessmentInfo.schema)
      })
    )
  })
);
var enabledOptionsResponse = new SchemaValidator(
  Type21.Object({
    proctoringMethod: Type21.Array(
      Type21.Union([
        Type21.Literal("automated"),
        Type21.Literal("live"),
        Type21.Literal("pop-in"),
        Type21.Literal("pop-in-post-review")
      ])
    )
  })
);
var assessmentResourceUploadUrlResponse = new SchemaValidator(
  Type21.Object({
    uploadUrl: Type21.String()
  })
);
var fileTypeSchema = new SchemaValidator(
  Type21.Object({
    name: Type21.String(),
    url: Type21.String(),
    size: Type21.Number(),
    expiresAt: Type21.Number()
  })
);
var getAssessmentResourcesResponse = new SchemaValidator(Type21.Array(fileTypeSchema.schema));
var schema_validators_default21 = {
  proctoringAssessmentConfigurationV2,
  proctoringAssessmentConfigurationV2OrNull,
  proctoringAssessmentConfigurationResponse,
  enabledOptionsResponse,
  assessmentResourceUploadUrlResponse,
  getAssessmentResourcesResponse,
  fileTypeSchema
};

// src/schemas/typebox/proctoring-session/schema-validators.ts
import { Type as Type22 } from "@sinclair/typebox";
function StringLiteralUnion(values) {
  const literals = values.map((value) => Type22.Literal(value));
  return Type22.Union(literals);
}
var startProctoring = new SchemaValidator(
  Type22.Object({
    sessionId: Type22.String(),
    proctoringOptions: schema_validators_default2.verityOptions.schema
  })
);
var recordingBlobInfo = new SchemaValidator(
  Type22.Object({
    proctoringSessionId: Type22.String(),
    recordingType: Type22.Union([Type22.Literal("display"), Type22.Literal("webcam")]),
    recordingNumber: Type22.Number(),
    blobNumber: Type22.Number()
  })
);
var uploadS3Url = new SchemaValidator(
  Type22.Object({
    url: Type22.String()
  })
);
var lmsContext = new SchemaValidator(
  Type22.Object({
    institute: Type22.Object({
      id: Type22.Number(),
      origin: OptionalOrNull(Type22.String()),
      accessControlUuid: Type22.String()
    }),
    course: Type22.Object({
      id: Type22.Number(),
      courseId: Type22.String(),
      accessControlUuid: Type22.String()
    }),
    assessment: Type22.Object({
      id: Type22.Number(),
      quizId: Type22.String()
    })
  })
);
var mediaAvailability = StringLiteralUnion(["unavailable", "processing", "available", "error"]);
var sessionStatus = StringLiteralUnion(["unflagged", "flagged", "incomplete", "pending", "error", "unavailable"]);
var videoAvailabilityList = Type22.Object({
  available: Type22.Array(Type22.Union([Type22.Number(), Type22.String(), Type22.Null()])),
  processing: Type22.Array(Type22.Union([Type22.Number(), Type22.String(), Type22.Null()]))
  // error: Type.Array(Type.Number()),
});
var userInfo = Type22.Object({
  username: OptionalOrNull(Type22.String()),
  full_name: OptionalOrNull(Type22.String()),
  given_name: OptionalOrNull(Type22.String()),
  family_name: OptionalOrNull(Type22.String()),
  email: OptionalOrNull(Type22.String()),
  profile_picture: OptionalOrNull(Type22.String())
});
var signatureType = Type22.Union([Type22.Literal("drawn"), Type22.Literal("photo"), Type22.Null()]);
var testResults = new SchemaValidator(
  Type22.Array(
    Type22.Object({
      id: Type22.Number(),
      studentId: Type22.Number(),
      lmsQuizId: Type22.Number(),
      uuid: Type22.String(),
      screencaptureAvailability: mediaAvailability,
      webcamAvailability: mediaAvailability,
      screencaptureVideos: OptionalOrNull(videoAvailabilityList),
      webcamVideos: OptionalOrNull(videoAvailabilityList),
      idPhotoAvailable: Type22.Boolean(),
      personPhotoAvailable: Type22.Boolean(),
      userInfo: OptionalOrNull(userInfo),
      startTime: OptionalOrNull(Type22.String()),
      endTime: OptionalOrNull(Type22.String()),
      status: OptionalOrNull(sessionStatus),
      lmsQuizName: OptionalOrNull(Type22.String()),
      createdAt: OptionalOrNull(Type22.String()),
      realQuizId: OptionalOrNull(Type22.String()),
      lmsUserId: OptionalOrNull(Type22.String()),
      flagLevel: OptionalOrNull(Type22.Number()),
      hasNotes: Type22.Boolean(),
      hasRoomScanNotes: Type22.Boolean(),
      isRoomScanDeleted: Type22.Boolean(),
      roomScanDeleteCause: OptionalOrNull(Type22.String()),
      roomScanDeleteAt: OptionalOrNull(Type22.String()),
      isWebcamAndScreenCaptureDeleted: Type22.Boolean(),
      webcamAndScreenCaptureDeleteCause: OptionalOrNull(Type22.String()),
      webcamAndScreenCaptureDeleteAt: OptionalOrNull(Type22.String()),
      signatureType,
      liveSessionId: OptionalOrNull(Type22.String()),
      liveUserSessionId: OptionalOrNull(Type22.String())
    })
  )
);
var singleEventType = Type22.Object({
  id: Type22.Number(),
  type: Type22.String(),
  name: Type22.String(),
  details: Type22.Record(Type22.String(), Type22.Any()),
  time: Type22.String(),
  proctoringSessionId: Type22.Number(),
  anomalyRef: OptionalOrNull(Type22.Number())
});
var singleEvent = new SchemaValidator(singleEventType);
var proctoringEvent = new SchemaValidator(
  Type22.Object({
    events: Type22.Array(singleEventType),
    anomalies: Type22.Array(
      Type22.Object({
        type: Type22.String(),
        flagLevel: Type22.Number(),
        timeStart: OptionalOrNull(Type22.String()),
        timeEnd: OptionalOrNull(Type22.String()),
        id: Type22.Number(),
        comment: OptionalOrNull(Type22.String()),
        resolved: Type22.Boolean()
      })
    )
  })
);
var sessionNotes = new SchemaValidator(
  Type22.Array(
    Type22.Object({
      id: Type22.Number(),
      content: Type22.String(),
      timestamp: Type22.String()
    })
  )
);
var roomScanNotes = new SchemaValidator(
  Type22.Array(
    Type22.Object({
      id: Type22.Number(),
      content: Type22.String(),
      timestamp: Type22.Number()
    })
  )
);
var count = new SchemaValidator(Type22.Number());
var concatenationRequestId = new SchemaValidator(Type22.Object({ requestId: Type22.String() }));
var concatenationRequest = new SchemaValidator(
  Type22.Object({
    status: Type22.Union([
      Type22.Literal("POSTPROCESS_STARTED"),
      Type22.Literal("POSTPROCESS_COMPLETE"),
      Type22.Literal("POSTPROCESS_FAILED")
    ])
  })
);
var proctoringSession = new SchemaValidator(
  Type22.Object({
    id: Type22.Number(),
    uuid: Type22.String(),
    studentId: Type22.Number(),
    ipAddress: OptionalOrNull(Type22.String()),
    status: OptionalOrNull(sessionStatus),
    startTime: OptionalOrNull(Type22.String())
  })
);
var baseQuizResponseItem = new SchemaValidator(
  Type22.Object({
    id: Type22.Number(),
    sessionId: Type22.Number(),
    questionNo: Type22.Number(),
    answer: OptionalOrNull(schema_validators_default3.quizAnswer.schema),
    isAnswered: Type22.Boolean(),
    createdAt: Type22.String(),
    updatedAt: Type22.String()
  })
);
var studentQuizResponseItem = Type22.Object({
  ...baseQuizResponseItem.schema.properties,
  grading: Type22.Object({
    score: OptionalOrNull(Type22.Number()),
    notes: OptionalOrNull(Type22.String())
  })
});
var instructorQuizResponseItem = Type22.Object({
  ...baseQuizResponseItem.schema.properties,
  grading: Type22.Object({
    score: Type22.Number(),
    notes: Type22.String(),
    publishedScore: OptionalOrNull(Type22.Number()),
    publishedNotes: OptionalOrNull(Type22.String()),
    hasUnpublishedChanges: Type22.Boolean()
  })
});
var studentQuizSessionData = new SchemaValidator(
  Type22.Object({
    responses: Type22.Array(studentQuizResponseItem),
    questions: Type22.Array(schema_validators_default3.studentQuizQuestion.schema)
  })
);
var instructorQuizSessionData = new SchemaValidator(
  Type22.Object({
    responses: Type22.Array(instructorQuizResponseItem),
    questions: Type22.Array(schema_validators_default3.instructorQuizQuestion.schema),
    syncError: OptionalOrNull(Type22.Boolean())
  })
);
var updateQuizResponseInput = new SchemaValidator(
  Type22.Object({
    id: Type22.Number(),
    score: OptionalOrNull(Type22.Number()),
    answer: OptionalOrNull(schema_validators_default3.quizAnswer.schema),
    isAnswered: OptionalOrNull(Type22.Boolean()),
    notes: OptionalOrNull(Type22.String())
  })
);
var paginatedEventsWithSessions = new SchemaValidator(
  PaginatedResults(Type22.Intersect([singleEventType, Type22.Object({ proctoringSession: proctoringSession.schema })]))
);
var sessionSummary = new SchemaValidator(
  Type22.Object({
    source: Type22.Union([Type22.Literal("ai"), Type22.Literal("liveProctor")]),
    summary: Type22.Object({
      summary: OptionalOrNull(Type22.String()),
      severe: OptionalOrNull(Type22.String()),
      major: OptionalOrNull(Type22.String()),
      minor: OptionalOrNull(Type22.String())
    })
  })
);
var supportChatResponse = new SchemaValidator(
  Type22.Object({
    message: Type22.String()
  })
);
var supportChatHistoryResponse = new SchemaValidator(
  Type22.Object({
    history: Type22.Array(
      Type22.Object({
        role: Type22.Union([Type22.Literal("user"), Type22.Literal("assistant")]),
        message: Type22.String(),
        timestamp: Type22.Number()
      })
    )
  })
);
var bedrockMessage = new SchemaValidator(
  Type22.Object({
    role: Type22.Union([Type22.Literal("user"), Type22.Literal("assistant")]),
    content: Type22.Array(
      Type22.Object({
        text: Type22.String()
      })
    )
  })
);
var assessmentSubmissionUploadUrlResponse = new SchemaValidator(
  Type22.Object({
    uploadUrl: Type22.String()
  })
);
var getAssessmentSubmissionResponse = new SchemaValidator(
  Type22.Array(schema_validators_default21.fileTypeSchema.schema)
);
var getStudentSubmissionsByAssessmentResponse = new SchemaValidator(
  Type22.Array(
    Type22.Object({
      files: Type22.Array(schema_validators_default21.fileTypeSchema.schema),
      uuid: Type22.String(),
      status: OptionalOrNull(sessionStatus),
      startTime: OptionalOrNull(Type22.String()),
      endTime: OptionalOrNull(Type22.String()),
      totalScore: OptionalOrNull(Type22.Number()),
      score: OptionalOrNull(Type22.Number())
    })
  )
);
var getAssessmentSubmissionCount = new SchemaValidator(Type22.Number());
var schema_validators_default22 = {
  startProctoring,
  lmsContext,
  testResults,
  proctoringEvent,
  recordingBlobInfo,
  uploadS3Url,
  url: uploadS3Url,
  sessionNotes,
  roomScanNotes,
  count,
  concatenationRequestId,
  concatenationRequest,
  proctoringSession,
  paginatedEventsWithSessions,
  singleEvent,
  sessionSummary,
  supportChatResponse,
  supportChatHistoryResponse,
  bedrockMessage,
  assessmentSubmissionUploadUrlResponse,
  updateQuizResponseInput,
  studentQuizSessionData,
  instructorQuizSessionData,
  getAssessmentSubmissionResponse,
  getStudentSubmissionsByAssessmentResponse,
  getAssessmentSubmissionCount
};

// src/schemas/typebox/proctoring-session/state/schema-validators.ts
import { Type as Type23 } from "@sinclair/typebox";
var proctoringSessionState = new SchemaValidator(
  Type23.Object({
    status: Type23.Union([Type23.String(), Type23.Undefined()])
  })
);
var schema_validators_default23 = {
  proctoringSessionState
};

// src/schemas/typebox/proctoring-session/logger/access-code/schema-validators.ts
import { Type as Type24 } from "@sinclair/typebox";
var accessCodeDisableEvent = new SchemaValidator(
  Type24.Object({
    type: Type24.Literal("access code"),
    name: Type24.Literal("save password disabled"),
    time: Type24.Date(),
    details: Type24.Object({
      success: Type24.Boolean()
    })
  })
);
var accessCodeResetEvent = new SchemaValidator(
  Type24.Object({
    type: Type24.Literal("access code"),
    name: Type24.Literal("save password reset"),
    time: Type24.Date(),
    details: Type24.Object({
      success: Type24.Boolean()
    })
  })
);
var accessCodeAutofillEvent = new SchemaValidator(
  Type24.Object({
    type: Type24.Literal("access code"),
    name: Type24.Literal("autofill"),
    time: Type24.Date(),
    details: Type24.Object({
      success: Type24.Boolean(),
      password: Type24.Optional(Type24.String())
    })
  })
);
var schema_validators_default24 = {
  accessCodeDisableEvent,
  accessCodeResetEvent,
  accessCodeAutofillEvent
};

// src/schemas/typebox/proctoring-session/logger/clipboard/schema-validators.ts
import { Type as Type25 } from "@sinclair/typebox";
var clipboardDisableEvent = new SchemaValidator(
  Type25.Object({
    type: Type25.Literal("clipboard"),
    name: Type25.Literal("disable"),
    time: Type25.Date(),
    details: Type25.Object({
      success: Type25.Boolean()
    })
  })
);
var clipboardKeypressEvent = new SchemaValidator(
  Type25.Object({
    type: Type25.Literal("clipboard"),
    name: Type25.Literal("keypress"),
    time: Type25.Date(),
    details: Type25.Object({
      keypress: Type25.String(),
      value: Type25.Optional(Type25.String())
    })
  })
);
var schema_validators_default25 = {
  clipboardDisableEvent,
  clipboardKeypressEvent
};

// src/schemas/typebox/proctoring-session/logger/face-detection/schema-validators.ts
import { Type as Type26 } from "@sinclair/typebox";
var otherFaceDetectedEvent = new SchemaValidator(
  Type26.Object({
    type: Type26.Literal("face detection"),
    name: Type26.Literal("other"),
    time: Type26.Date(),
    details: Type26.Object({
      count: Type26.Number()
    })
  })
);
var targetFaceDetectedEvent = new SchemaValidator(
  Type26.Object({
    type: Type26.Literal("face detection"),
    name: Type26.Literal("target"),
    time: Type26.Date(),
    details: Type26.Object({
      count: Type26.Number()
    })
  })
);
var schema_validators_default26 = {
  otherFaceDetectedEvent,
  targetFaceDetectedEvent
};

// src/schemas/typebox/proctoring-session/logger/http/schema-validators.ts
import { Type as Type27 } from "@sinclair/typebox";
var httpWebNavigationEvent = new SchemaValidator(
  Type27.Object({
    type: Type27.Literal("web navigation"),
    name: Type27.Union([Type27.Literal("webRequest"), Type27.Literal("webNavigation")]),
    time: Type27.Date(),
    details: Type27.Object({
      url: Type27.String(),
      method: Type27.Optional(Type27.String()),
      frame: Type27.Optional(Type27.String())
    })
  })
);
var schema_validators_default27 = {
  httpWebNavigationEvent
};

// src/schemas/typebox/proctoring-session/logger/id/schema-validators.ts
import { Type as Type28 } from "@sinclair/typebox";
var idEvent = new SchemaValidator(
  Type28.Object({
    type: Type28.Literal("id"),
    name: Type28.Union([Type28.Literal("face id mismatch"), Type28.Literal("bypassed ai detection")]),
    time: Type28.Date(),
    details: Type28.Object({
      similarity: Type28.Optional(Type28.Number({ minimum: 0, maximum: 1 })),
      success: Type28.Optional(Type28.Boolean())
    })
  })
);
var schema_validators_default28 = {
  idEvent
};

// src/schemas/typebox/proctoring-session/logger/interrupt/schema-validators.ts
import { Type as Type29 } from "@sinclair/typebox";
var interruptTriggerEvent = new SchemaValidator(
  Type29.Object({
    type: Type29.Literal("interrupt"),
    name: Type29.Literal("trigger"),
    time: Type29.Date(),
    details: Type29.Object({
      success: Type29.Boolean(),
      type: Type29.Union([
        Type29.Literal("webcam"),
        Type29.Literal("display"),
        Type29.Literal("monitor count"),
        Type29.Literal("face recorder"),
        Type29.Literal("speaking"),
        Type29.Literal("enables_blocked_extension")
      ]),
      extNames: Type29.Optional(Type29.Array(Type29.String()))
    })
  })
);
var interruptResumeEvent = new SchemaValidator(
  Type29.Object({
    type: Type29.Literal("interrupt"),
    name: Type29.Literal("resume"),
    time: Type29.Date(),
    details: Type29.Object({
      success: Type29.Boolean(),
      type: Type29.Union([
        Type29.Literal("webcam"),
        Type29.Literal("display"),
        Type29.Literal("monitor count"),
        Type29.Literal("face recorder"),
        Type29.Literal("enables_blocked_extension")
      ])
    })
  })
);
var schema_validators_default29 = {
  interruptTriggerEvent,
  interruptResumeEvent
};

// src/schemas/typebox/proctoring-session/logger/keyboard/schema-validators.ts
import { Type as Type30 } from "@sinclair/typebox";
var keyboardKeypressEvent = new SchemaValidator(
  Type30.Object({
    type: Type30.Literal("keyboard"),
    name: Type30.Literal("keypress"),
    time: Type30.Date(),
    details: Type30.Object({
      value: Type30.String()
    })
  })
);
var schema_validators_default30 = {
  keyboardKeypressEvent
};

// src/schemas/typebox/proctoring-session/logger/live/schema-validators.ts
import { Type as Type31 } from "@sinclair/typebox";
var liveBuildAudioBridgeEvent = new SchemaValidator(
  Type31.Object({
    type: Type31.Literal("live"),
    name: Type31.Literal("audio bridge"),
    time: Type31.Date(),
    details: Type31.Object({
      success: Type31.Boolean()
    })
  })
);
var liveProctorJoinedEvent = new SchemaValidator(
  Type31.Object({
    type: Type31.Literal("live"),
    name: Type31.Literal("proctor joined"),
    time: Type31.Date(),
    details: Type31.Object({
      proctorId: Type31.String(),
      count: Type31.Optional(Type31.Number())
    })
  })
);
var liveProctorLeftEvent = new SchemaValidator(
  Type31.Object({
    type: Type31.Literal("live"),
    name: Type31.Literal("proctor left"),
    time: Type31.Date(),
    details: Type31.Object({
      proctorId: Type31.String(),
      count: Type31.Optional(Type31.Number())
    })
  })
);
var liveJoinSessionEvent = new SchemaValidator(
  Type31.Object({
    type: Type31.Literal("live"),
    name: Type31.Literal("join session"),
    time: Type31.Date(),
    details: Type31.Object({
      liveSessionId: Type31.String(),
      liveUserSessionId: Type31.String(),
      proctorIds: Type31.Optional(Type31.Array(Type31.String())),
      proctorGroupIds: Type31.Optional(Type31.Array(Type31.Number()))
    })
  })
);
var noProctorsEvent = new SchemaValidator(
  Type31.Object({
    type: Type31.Literal("live"),
    name: Type31.Literal("no proctors"),
    time: Type31.Date(),
    details: Type31.Object({
      isOnJoin: Type31.Boolean()
    })
  })
);
var schema_validators_default31 = {
  liveBuildAudioBridgeEvent,
  liveProctorJoinedEvent,
  liveProctorLeftEvent,
  liveJoinSessionEvent,
  noProctorsEvent
};

// src/schemas/typebox/proctoring-session/logger/media/schema-validators.ts
import { Type as Type32 } from "@sinclair/typebox";
var logStartRecording = new SchemaValidator(Type32.String());
var schema_validators_default32 = {
  logStartRecording
};

// src/schemas/typebox/proctoring-session/logger/screenshot/schema-validators.ts
import { Type as Type33 } from "@sinclair/typebox";
var screenshotDisableEvent = new SchemaValidator(
  Type33.Object({
    type: Type33.Literal("screenshot"),
    name: Type33.Literal("disable"),
    time: Type33.Date(),
    details: Type33.Object({
      success: Type33.Boolean()
    })
  })
);
var screenshotKeypressEvent = new SchemaValidator(
  Type33.Object({
    type: Type33.Literal("screenshot"),
    name: Type33.Literal("keypress"),
    time: Type33.Date(),
    details: Type33.Object({
      keypress: Type33.String()
    })
  })
);
var schema_validators_default33 = {
  screenshotDisableEvent,
  screenshotKeypressEvent
};

// src/schemas/typebox/proctoring-session/logger/session/schema-validators.ts
import { Type as Type34 } from "@sinclair/typebox";
var startAssessmentEvent = new SchemaValidator(
  Type34.Object({
    type: Type34.Literal("session"),
    name: Type34.Literal("start quiz"),
    time: Type34.Date(),
    details: Type34.Object({
      success: Type34.Boolean()
    })
  })
);
var endAssessmentEvent = new SchemaValidator(
  Type34.Object({
    type: Type34.Literal("session"),
    name: Type34.Literal("end quiz"),
    time: Type34.Date(),
    details: Type34.Object({
      success: Type34.Boolean()
    })
  })
);
var endProctoringEvent = new SchemaValidator(
  Type34.Object({
    type: Type34.Literal("session"),
    name: Type34.Literal("end proctoring"),
    time: Type34.Date(),
    details: Type34.Object({
      success: Type34.Boolean()
    })
  })
);
var schema_validators_default34 = {
  startAssessmentEvent,
  endAssessmentEvent,
  endProctoringEvent
};

// src/schemas/typebox/proctoring-session/logger/system/schema-validators.ts
import { Type as Type35 } from "@sinclair/typebox";
var connectionCheckEvent = new SchemaValidator(
  Type35.Object({
    type: Type35.Literal("system"),
    name: Type35.Literal("connection check"),
    time: Type35.Date(),
    details: Type35.Object({
      metrics: Type35.Any(),
      uploadSpeed: Type35.Number()
    })
  })
);
var systemResourceEvent = new SchemaValidator(
  Type35.Object({
    type: Type35.Literal("system"),
    name: Type35.Literal("system resources"),
    time: Type35.Date(),
    details: Type35.Object({
      cpuUsage: Type35.Number(),
      memoryUsage: Type35.Number()
    })
  })
);
var notInGeofenceEvent = new SchemaValidator(
  Type35.Object({
    type: Type35.Literal("system"),
    name: Type35.Literal("not in geofence"),
    time: Type35.Date(),
    details: Type35.Object({})
  })
);
var locationUnknownEvent = new SchemaValidator(
  Type35.Object({
    type: Type35.Literal("system"),
    name: Type35.Literal("location unknown"),
    time: Type35.Date(),
    details: Type35.Object({})
  })
);
var installedExtensionsSnapshotEvent = new SchemaValidator(
  Type35.Object({
    type: Type35.Literal("system"),
    name: Type35.Literal("installed extensions snapshot"),
    time: Type35.Date(),
    details: Type35.Object({
      extensions: Type35.Array(
        Type35.Object({
          id: Type35.String(),
          name: Type35.String()
        })
      )
    })
  })
);
var schema_validators_default35 = {
  connectionCheckEvent,
  systemResourceEvent,
  notInGeofenceEvent,
  locationUnknownEvent,
  installedExtensionsSnapshotEvent
};

// src/schemas/typebox/proctoring-session/logger/tab/schema-validators.ts
import { Type as Type36 } from "@sinclair/typebox";
var tabCloseOneEvent = new SchemaValidator(
  Type36.Object({
    type: Type36.Literal("tab"),
    name: Type36.Literal("close one"),
    time: Type36.Date(),
    details: Type36.Object({
      url: Type36.String(),
      title: Type36.String(),
      autoClose: Type36.Boolean()
    })
  })
);
var tabCreateEvent = new SchemaValidator(
  Type36.Object({
    type: Type36.Literal("tab"),
    name: Type36.Literal("create"),
    time: Type36.Date(),
    details: Type36.Object({
      url: Type36.String(),
      title: Type36.String()
    })
  })
);
var tabWhitelistEvent = new SchemaValidator(
  Type36.Object({
    type: Type36.Literal("tab"),
    name: Type36.Literal("whitelist"),
    time: Type36.Date(),
    details: Type36.Object({
      success: Type36.Boolean(),
      whiteList: Type36.Array(Type36.String())
    })
  })
);
var tabDisableEvent = new SchemaValidator(
  Type36.Object({
    type: Type36.Literal("tab"),
    name: Type36.Literal("disable"),
    time: Type36.Date(),
    details: Type36.Object({
      success: Type36.Boolean()
    })
  })
);
var tabFocusEvent = new SchemaValidator(
  Type36.Object({
    type: Type36.Literal("tab"),
    name: Type36.Literal("focus"),
    time: Type36.Date(),
    details: Type36.Object({
      focus: Type36.Boolean()
    })
  })
);
var schema_validators_default36 = {
  tabCloseOneEvent,
  tabCreateEvent,
  tabWhitelistEvent,
  tabDisableEvent,
  tabFocusEvent
};

// src/schemas/typebox/proctoring-session/logger/user-action/schema-validators.ts
import { Type as Type37 } from "@sinclair/typebox";
var sidePanelDetectedEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("user action"),
    name: Type37.Literal("side panel detected"),
    time: Type37.Date(),
    details: Type37.Object({})
  })
);
var rightClickBlockedEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("user action"),
    name: Type37.Literal("right click blocked"),
    time: Type37.Date(),
    details: Type37.Object({})
  })
);
var printingBlockedEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("user action"),
    name: Type37.Literal("printing blocked"),
    time: Type37.Date(),
    details: Type37.Object({})
  })
);
var typedSignatureEvent = new SchemaValidator(
  Type37.Object({
    type: Type37.Literal("user action"),
    name: Type37.Literal("typed signature"),
    time: Type37.Date(),
    details: Type37.Object({
      signature: Type37.String()
    })
  })
);
var schema_validators_default37 = {
  sidePanelDetectedEvent,
  rightClickBlockedEvent,
  printingBlockedEvent,
  typedSignatureEvent
};

// src/schemas/typebox/proctoring-session/logger/worker/schema-validators.ts
import { Type as Type38 } from "@sinclair/typebox";
var detectedFace = Type38.Object({
  bbox: Type38.Object({
    normalizedX: Type38.Number(),
    normalizedY: Type38.Number(),
    normalizedWidth: Type38.Number(),
    normalizedHeight: Type38.Number()
  }),
  bboxRaw: Type38.Object({
    x: Type38.Number(),
    y: Type38.Number(),
    width: Type38.Number(),
    height: Type38.Number()
  }),
  score: Type38.Number(),
  gestures: Type38.Array(Type38.String()),
  similarity: OptionalOrNull(Type38.Number()),
  embedding: OptionalOrNull(Type38.Array(Type38.Number()))
});
var faceWorkerEvent = new SchemaValidator(
  Type38.Partial(
    Type38.Object({
      type: Type38.String(),
      name: Type38.String(),
      time: Type38.Date(),
      details: Type38.Object({
        topic: Type38.String(),
        metadata: OptionalOrNull(
          Type38.Object({
            duration: OptionalOrNull(Type38.Number())
          })
        ),
        detections: Type38.Array(Type38.Partial(detectedFace))
      })
    })
  )
);
var detectedObject = Type38.Object({
  bbox: Type38.Object({
    normalizedX: Type38.Number(),
    normalizedY: Type38.Number(),
    normalizedWidth: Type38.Number(),
    normalizedHeight: Type38.Number()
  }),
  bboxRaw: Type38.Object({
    x: Type38.Number(),
    y: Type38.Number(),
    width: Type38.Number(),
    height: Type38.Number()
  }),
  score: Type38.Number(),
  name: Type38.String()
});
var objectWorkerEvent = new SchemaValidator(
  Type38.Partial(
    Type38.Object({
      type: Type38.String(),
      name: Type38.String(),
      time: Type38.Date(),
      details: Type38.Object({
        topic: Type38.String(),
        metadata: OptionalOrNull(
          Type38.Object({
            duration: OptionalOrNull(Type38.Number())
          })
        ),
        detections: Type38.Array(Type38.Partial(detectedObject))
      })
    })
  )
);
var schema_validators_default38 = {
  faceWorkerEvent,
  objectWorkerEvent
};

// src/schemas/typebox/report/schema-validators.ts
var schema_validators_default39 = {};

// src/schemas/typebox/roster/schema-validators.ts
import { Type as Type39 } from "@sinclair/typebox";
var getRosterStatistics = new SchemaValidator(
  Type39.Object({
    TOTAL: Type39.Number(),
    ADMIN: Type39.Number(),
    INSTRUCTOR: Type39.Number(),
    STUDENT: Type39.Number()
  })
);
var privilegeGroupIds = new SchemaValidator(Type39.Array(Type39.Number()));
var schema_validators_default40 = {
  getRosterStatistics,
  privilegeGroupIds
};

// src/schemas/typebox/saml/schema-validators.ts
import { Type as Type40 } from "@sinclair/typebox";
var assertingPartyDetails = new SchemaValidator(
  Type40.Object({
    entityId: Type40.Union([Type40.String(), Type40.Null()]),
    wantAuthnRequestsSigned: Type40.Union([Type40.Boolean(), Type40.Null()]),
    singleSignOnServiceLocation: Type40.Union([Type40.String(), Type40.Null()]),
    singleSignOnServiceBindingUrn: Type40.Union([Type40.String(), Type40.Null()]),
    singleLogoutServiceLocation: Type40.Union([Type40.String(), Type40.Null()]),
    singleLogoutServiceResponseLocation: Type40.Union([Type40.String(), Type40.Null()]),
    singleLogoutServiceBindingUrn: Type40.Union([Type40.String(), Type40.Null()]),
    signingAlgorithms: Type40.Array(Type40.String()),
    verificationX509Credentials: Type40.Array(
      Type40.Object({
        certificate: Type40.String(),
        type: Type40.String()
      })
    ),
    encryptionX509Credentials: Type40.Array(
      Type40.Object({
        certificate: Type40.String(),
        type: Type40.String()
      })
    )
  })
);
var attributeMapping = new SchemaValidator(
  Type40.Object({
    email: Type40.Union([Type40.String(), Type40.Null()]),
    name: Type40.Union([Type40.String(), Type40.Null()]),
    role: Type40.Union([Type40.String(), Type40.Null()]),
    linkage: Type40.Union([Type40.String(), Type40.Null()])
  })
);
var roleMapping = new SchemaValidator(
  Type40.Object({
    id: Type40.Number(),
    attribute: Type40.String(),
    privilegeGroupId: Type40.Number(),
    requiredParentPrivilegeGroupId: OptionalOrNull(Type40.Integer())
  })
);
var relyingPartyRegistrationIds = {
  instituteId: Type40.String(),
  registrationId: Type40.String()
};
var relyingPartyRegistration = new SchemaValidator(
  Type40.Object({
    ...relyingPartyRegistrationIds,
    metadataLocation: Type40.Union([Type40.String(), Type40.Null()]),
    nameIdFormat: Type40.Union([Type40.String(), Type40.Null()]),
    assertingPartyDetails: Type40.Union([assertingPartyDetails.schema, Type40.Null()]),
    attributeMapping: Type40.Union([attributeMapping.schema, Type40.Null()]),
    roleMappings: Type40.Union([Type40.Array(roleMapping.schema), Type40.Null()]),
    linkUsersByEmail: Type40.Boolean(),
    enabled: Type40.Boolean()
  })
);
var getRelyingPartyRegistrations = new SchemaValidator(
  Type40.Object({
    content: Type40.Array(relyingPartyRegistration.schema)
  })
);
var getRelyingPartyRegistrationIds = new SchemaValidator(
  Type40.Object({
    content: Type40.Array(Type40.Object(relyingPartyRegistrationIds))
  })
);
var addRoleMapping = new SchemaValidator(
  Type40.Object({
    attribute: Type40.String(),
    privilegeGroupId: Type40.Number(),
    requiredParentPrivilegeGroupId: OptionalOrNull(Type40.Integer())
  })
);
var updateRelyingPartyRegistration = new SchemaValidator(
  Type40.Object({
    metadataLocation: Type40.Union([Type40.String(), Type40.Null()]),
    nameIdFormat: Type40.Union([Type40.String(), Type40.Null()]),
    assertingPartyDetails: Type40.Union([assertingPartyDetails.schema, Type40.Null()]),
    attributeMapping: Type40.Union([attributeMapping.schema, Type40.Null()]),
    linkUsersByEmail: Type40.Boolean(),
    enabled: Type40.Union([Type40.Boolean(), Type40.Null()])
  })
);
var createRelyingPartyRegistration = new SchemaValidator(
  Type40.Object({
    instituteId: Type40.String(),
    registrationId: Type40.Union([Type40.String(), Type40.Null()]),
    metadataLocation: Type40.Union([Type40.String(), Type40.Null()]),
    nameIdFormat: Type40.Union([Type40.String(), Type40.Null()]),
    assertingPartyDetails: Type40.Union([assertingPartyDetails.schema, Type40.Null()]),
    attributeMapping: Type40.Union([attributeMapping.schema, Type40.Null()]),
    roleMappings: Type40.Union([Type40.Array(addRoleMapping.schema), Type40.Null()]),
    linkUsersByEmail: Type40.Boolean(),
    enabled: Type40.Union([Type40.Boolean(), Type40.Null()])
  })
);
var getRoleMappingPresets = new SchemaValidator(
  Type40.Array(
    Type40.Object({
      preset: Type40.Union([Type40.Literal("STUDENT"), Type40.Literal("INSTRUCTOR"), Type40.Literal("ADMIN")]),
      privilegeGroupId: Type40.Number(),
      requiredParentPrivilegeGroupId: OptionalOrNull(Type40.Integer())
    })
  )
);
var schema_validators_default41 = {
  relyingPartyRegistration,
  getRelyingPartyRegistrations,
  getRelyingPartyRegistrationIds,
  addRoleMapping,
  updateRelyingPartyRegistration,
  createRelyingPartyRegistration,
  getRoleMappingPresets
};

// src/schemas/typebox/scratch-note/schema-validators.ts
import { Type as Type41 } from "@sinclair/typebox";
var createUploadGrant = new SchemaValidator(
  Type41.Object({
    id: Type41.String(),
    url: Type41.String()
  })
);
var getLinks = new SchemaValidator(
  Type41.Array(
    Type41.Object({
      id: Type41.String(),
      url: Type41.String(),
      uploadedAt: Type41.Optional(Type41.Number())
    })
  )
);
var schema_validators_default42 = {
  createUploadGrant,
  getLinks
};

// src/schemas/typebox/start-assessment/schema-validators.ts
import { Type as Type42 } from "@sinclair/typebox";
var checkUserAndAuthenticateResponse = new SchemaValidator(
  Type42.Object({
    eligible: Type42.Boolean(),
    exempted: Type42.Boolean(),
    error: Type42.Optional(
      Type42.Union([
        Type42.String(),
        Type42.Object({
          kind: Type42.Literal("incompatibleBrowser"),
          data: Type42.Object({
            compatibleBrowsers: Type42.Object({
              chrome: Type42.Boolean(),
              firefox: Type42.Boolean(),
              safari: Type42.Boolean()
            })
          })
        })
      ])
    ),
    platforms: Type42.Optional(
      Type42.Object({
        isExtension: Type42.Boolean(),
        isLockdown: Type42.Boolean(),
        isMobile: Type42.Boolean(),
        isChromeOs: Type42.Boolean()
      })
    )
  })
);
var getUploadContextResponse = new SchemaValidator(
  Type42.Object({
    quizName: OptionalOrNull(Type42.String()),
    courseName: OptionalOrNull(Type42.String()),
    studentName: OptionalOrNull(Type42.String()),
    fileFormats: Type42.Array(Type42.String()),
    count: Type42.Number(),
    canUpload: Type42.Boolean()
  })
);
var schema_validators_default43 = {
  checkUserAndAuthenticateResponse,
  getUploadContextResponse
};

// src/schemas/typebox/support/schema-validators.ts
import { Type as Type43 } from "@sinclair/typebox";
var callAccessCode = new SchemaValidator(
  Type43.Object({
    accessCode: OptionalOrNull(Type43.Number())
  })
);
var schema_validators_default44 = {
  callAccessCode
};

// src/schemas/typebox/system-check/schema-validators.ts
var schema_validators_default45 = {};

// src/schemas/typebox/user/schema-validators.ts
import { Type as Type44 } from "@sinclair/typebox";
var studentType = Type44.Object({
  id: Type44.Number(),
  uuid: Type44.String(),
  name: Type44.String()
});
var students = new SchemaValidator(Type44.Array(studentType));
var studentId = new SchemaValidator(Type44.Object({ id: Type44.Number() }));
var exemptions = new SchemaValidator(
  Type44.Union([
    Type44.Null(),
    Type44.Array(
      Type44.Object({
        userId: Type44.Integer()
      })
    )
  ])
);
var accessControlUserInfo = new SchemaValidator(
  Type44.Object({
    id: Type44.String(),
    name: Type44.String(),
    platform: Type44.String(),
    instituteId: Type44.String(),
    timezone: Type44.String(),
    privilegeGroupIds: Type44.Array(Type44.Number())
  })
);
var proctoringExemptions = new SchemaValidator(
  Type44.Array(
    Type44.Object({
      type: Type44.String(),
      userId: Type44.Integer(),
      accommodationNotes: Type44.Optional(Type44.String()),
      proctoringOptionProfileId: Type44.Optional(Type44.Integer())
    })
  )
);
var exemptionStatus = new SchemaValidator(
  Type44.Object({
    exempt: Type44.Boolean(),
    proctoringOption: Type44.Optional(proctoringOptionType)
  })
);
var language = new SchemaValidator(Type44.Union([Type44.Literal("en"), Type44.Literal("fr"), Type44.Null()]));
var standaloneAccount = new SchemaValidator(
  Type44.Object({
    id: Type44.String(),
    userIds: Type44.Array(Type44.String(), { minItems: 1 })
  })
);
var notifications = new SchemaValidator(
  Type44.Array(
    Type44.Object({
      type: Type44.String(),
      details: OptionalOrNull(Type44.Unknown())
    })
  )
);
var loginCount = new SchemaValidator(
  Type44.Object({
    loginCount: Type44.Number()
  })
);
var hasShownWelcome = new SchemaValidator(
  Type44.Object({
    candidateWelcomeShownAt: Type44.Date()
  })
);
var schema_validators_default46 = {
  students,
  studentId,
  exemptions,
  proctoringExemptions,
  exemptionStatus,
  accessControlUserInfo,
  language,
  standaloneAccount,
  notifications,
  loginCount,
  hasShownWelcome
};
export {
  OptionalOrNull,
  PaginatedResults,
  SchemaValidator,
  schema_validators_default as adminSchemaValidators,
  schema_validators_default3 as assessmentSchemaValidators,
  schema_validators_default4 as authenticationSchemaValidators,
  schema_validators_default5 as basicAuthSchemaValidators,
  candidateInterviewOptionsBaseType,
  candidateInterviewOptionsGetType,
  candidateInterviewOptionsSaveType,
  chromeOsAccessType,
  schema_validators_default6 as courseSchemaValidators,
  schema_validators_default7 as downloadSchemaValidators,
  schema_validators_default8 as feedbackSchemaValidators,
  schema_validators_default9 as installationSchemaValidators,
  schema_validators_default11 as instituteSchemaValidators,
  schema_validators_default12 as integrationSchemaValidators,
  schema_validators_default13 as liveSchemaValidators,
  schema_validators_default14 as lmsInfoSchemaValidators,
  schema_validators_default15 as ltiSchemaValidators,
  schema_validators_default16 as mediaSchemaValidators,
  schema_validators_default17 as oauthSchemaValidators,
  schema_validators_default18 as paymentSchemaValidators,
  schema_validators_default19 as permissionSchemaValidators,
  schema_validators_default20 as platformInfoSchemaValidators,
  schema_validators_default21 as proctoringConfigurationSchemaValidators,
  proctoringOptionProfile,
  proctoringOptionType,
  proctoringOptionsType,
  schema_validators_default10 as proctoringProfileSchemaValidators,
  schema_validators_default24 as proctoringSessionLoggerAccessCodeSchemaValidators,
  schema_validators_default25 as proctoringSessionLoggerClipboardSchemaValidators,
  schema_validators_default26 as proctoringSessionLoggerFaceDetectionSchemaValidators,
  schema_validators_default27 as proctoringSessionLoggerHttpSchemaValidators,
  schema_validators_default28 as proctoringSessionLoggerIdSchemaValidators,
  schema_validators_default29 as proctoringSessionLoggerInterruptSchemaValidators,
  schema_validators_default30 as proctoringSessionLoggerKeyboardSchemaValidators,
  schema_validators_default31 as proctoringSessionLoggerLiveSchemaValidators,
  schema_validators_default32 as proctoringSessionLoggerMediaSchemaValidators,
  schema_validators_default33 as proctoringSessionLoggerScreenshotSchemaValidators,
  schema_validators_default34 as proctoringSessionLoggerSessionSchemaValidators,
  schema_validators_default35 as proctoringSessionLoggerSystemSchemaValidators,
  schema_validators_default36 as proctoringSessionLoggerTabSchemaValidators,
  schema_validators_default37 as proctoringSessionLoggerUserActionSchemaValidators,
  schema_validators_default38 as proctoringSessionLoggerWorkerSchemaValidators,
  schema_validators_default22 as proctoringSessionSchemaValidators,
  schema_validators_default23 as proctoringSessionStateSchemaValidators,
  schema_validators_default39 as reportSchemaValidators,
  schema_validators_default40 as rosterSchemaValidators,
  schema_validators_default41 as samlSchemaValidators,
  schema_validators_default42 as scratchNoteSchemaValidators,
  schema_validators_default43 as startAssessmentSchemaValidators,
  schema_validators_default44 as supportSchemaValidators,
  schema_validators_default45 as systemCheckSchemaValidators,
  schema_validators_default46 as userSchemaValidators,
  schema_validators_default2 as verityOptionsSchemaValidators
};
//# sourceMappingURL=index.js.map